import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { DataProvider } from './hooks/useData';
import { Amplify } from 'aws-amplify';
import awsConfig from './amplifyconfiguration.json';
import { AuthProvider } from './hooks/useAuth';
import store from './store';
import { Provider } from 'react-redux';

if (
    window.location.hostname === 'localhost' ||
    window.location.hostname === 'tax.localhost' ||
    window.location.hostname === 'checkout.localhost' ||
    window.location.hostname === 'online-cart.localhost'
) {
    awsConfig.aws_cloud_logic_custom = awsConfig.aws_cloud_logic_custom.map((config) => {
        config.endpoint = `http://localhost:3001`;
        return config;
    });
}

let application = 'client';
if (window.location.host === 'localhost:6001' || window.location.host.indexOf('preview') > -1) {
    application = 'preview';
}

Amplify.configure(awsConfig);

const renderApp = (
    <React.StrictMode>
        <BrowserRouter>
            <Provider store={store}>
                <AuthProvider application={application}>
                    <DataProvider>
                        <App />
                    </DataProvider>
                </AuthProvider>
            </Provider>
        </BrowserRouter>
    </React.StrictMode>
);

if (process.env.NODE_ENV !== 'production') {
    import('react-axe').then((axe) => {
        axe.default(React, ReactDOM, 1000);
        const root = ReactDOM.createRoot(document.getElementById('root'));
        root.render(renderApp);
    });
} else {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(renderApp);
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
